document.addEventListener('DOMContentLoaded', e => {
  const addCustomCSSForShopFollowButton = (button) => {
    const customStyle = document.createElement("style");
    customStyle.innerHTML = `
      .follow-text {
        background-color: #485047 !important;
        border-radius: 48px;
      }
    `;

    try {
      button.shadowRoot
        .querySelector("shop-follow-button")
        .shadowRoot.querySelector("follow-on-shop-button")
        .shadowRoot.querySelector("style")
        .after(customStyle);
    } catch (err) {
      console.warn("Error injecting custom style:", err);
    }
  };

  const button = document.querySelector('shop-login-button');

  if (button instanceof Node) {
    const config = { childList: true, subtree: true };

    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        console.log(mutation.type); // Fixed typo from 'constole'
        if (mutation.type === "childList") {
          addCustomCSSForShopFollowButton(button);
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(button, config);

    // Initial run
    addCustomCSSForShopFollowButton(button);
  } else {
    console.warn("shop-login-button not found. MutationObserver not started.");
  }
});

